var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"nav-wizard"},[_c('b-nav',{staticClass:"nav-pills nav-justified"},_vm._l((_vm.steps),function(step){return _c('sig-step-nav-step',{attrs:{"step":step,"currentstep":_vm.currentstep,"maxstep":_vm.maxstep},on:{"update-nav-step":_vm.updateCurrentStep}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }